module.exports = new __parcel__URL__("logo-light.49944d89.webp").toString();